import styles from "./PhotoSelection.module.css";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import JSZip from "jszip";
import gallery_icon from "../../../assets/images/icons/gallery_ace.svg";
import fav_icon from "../../../assets/images/icons/fav.png";
import fav_filled_icon from "../../../assets/images/icons/fav_filled.png";

import useAxios from "../../Hooks/useAxios";

const PhotoSelection = ({ skey, count, done, allowLessSelects = false }) => {
  const [imagesLeft, setImagesLeft] = useState(count);
  const backend_base = process.env.REACT_APP_API_BASE_URL;
  const image_base_url = `${backend_base}/media/`;
  const frontend_base = process.env.REACT_APP_FRONTEND_URL;
  const [freeAlbums, setFreeAlbums] = useState([]);
  const [passAlbums, setPassAlbums] = useState([]);
  const [galleryDetails, setGalleryDetails] = useState([]);
  const [favoritePictures, setFavoritePictures] = useState([]);
  const [gallery, setGallery] = useState([]);
  const [selected, setSelected] = useState(0);
  const [selectedImageIndex, setSelectedImageIndex] = useState([]);
  const [galleryType, setGalleryType] = useState([]);
  const navigate = useNavigate();
  const axios = useAxios();
  const [currentSelectedNumber, setCurrentSelectedNumber] = useState(1);

  useEffect(() => {
    console.log("Getting the images from gallery");
    axios
      .get(backend_base + "/shop/gallery", { key: skey })
      .then((res) => {
        if (res.status === 201 || res.status === 200) {
          console.log("Success Getting Albums");
          console.log(res.data);
          setFavoritePictures(res.data.favorite_pictures);
          setFreeAlbums(res.data.free_galleries);
          setPassAlbums(res.data.pass_galleries);
          const gals = [];
          const atype = [];
          const gDetails = [];
          for (let album of res.data.pass_galleries) {
            let temp = {
              name: album.name,
              subtitle: "年間パス利用中",
              images: album.images,
            };
            gals.push(temp);
            atype.push("PASS");
            gDetails.push(album);
          }
          for (let album of res.data.free_galleries) {
            let temp = {
              title: album.name,
              subtitle: "",
              images: album.images,
            };
            gals.push(temp);
            atype.push("FREE");
            gDetails.push(album);
          }
          if (gals.length === 0) {
            let temp = {
              title: "Upload",
              subtitle: "",
              images: [],
            };
            gals.push(temp);
            atype.push("UPLOAD");
            gDetails.push({});
          }
          gals.push({
            title: "お気に入り",
            subtitle: "",
            images: res.data.favorite_pictures,
          });
          atype.push("FAVORITE");
          gDetails.push(res.data.favorite_pictures);
          const tempGal = [];
          const tempType = [];
          const tempDetails = [];
          for (let i = 1; gals.length !== 0; i++) {
            if (i !== 1 && i % 6 === 0) {
              tempGal.push(0);
              tempType.push(0);
              tempDetails.push(0);
            } else {
              tempGal.push(gals.shift());
              tempType.push(atype.shift());
              tempDetails.push(gDetails.shift());
            }
          }
          if (tempGal[tempGal.length - 1] !== 0) {
            tempGal.push(0);
            tempType.push(0);
            tempDetails.push(0);
          }
          console.log("TEMPGAL");
          console.log(tempGal);
          //Handle Authentication
          setGallery(tempGal);
          setGalleryType(tempType);
          setGalleryDetails(tempDetails);
          let tempSelectedImageIndex = [];
          for (let i = 0; i < tempGal.length; i++) {
            const temp = [];
            if (tempGal[i] !== 0) {
              for (let j = 0; j < tempGal[i].images.length; j++) {
                temp.push(false);
              }
            }
            tempSelectedImageIndex.push(temp);
          }
          console.log(tempSelectedImageIndex);
          setSelectedImageIndex(tempSelectedImageIndex);
        } else {
          console.log("Failed");
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, []);
  const selectionDone = () => {
    if (imagesLeft === 0 || allowLessSelects) {
      console.log("selection done");
      console.log(selectedImageIndex[selected]);
      const uploaded_images = [];
      const selectedIndices = [];

      // Need to sort tertiary because of the changes to the xd
      for (let i = 0; i < selectedImageIndex.length; i++) {
        for (let j = 0; j < selectedImageIndex[i].length; j++) {
          if (selectedImageIndex[i][j]) {
            selectedIndices.push([i, j, selectedImageIndex[i][j]]);
          }
        }
      }

      // sorting based on image count vals so that they go back to my callback based on the order of selection
      selectedIndices.sort((a, b) => a[2] - b[2]);

      for (const [i, j] of selectedIndices) {
        uploaded_images.push(image_base_url + gallery[i].images[j].location);
      }

      done(uploaded_images);
    }
  };
  const alterSelection = (index) => {
    const temp = [...selectedImageIndex];
    console.log(temp);
    if (!temp[selected][index] && imagesLeft <= 0) {
      return;
    } else if (temp[selected][index]) {
      // get the number
      const deletedNumber = temp[selected][index];
      setCurrentSelectedNumber(currentSelectedNumber - 1);
      for (let i = 0; i < temp.length; i++) {
        for (let j = 0; j < temp[i].length; j++) {
          if (temp[i][j] && temp[i][j] > deletedNumber) {
            //item has been selected before
            //decrease if it is bigger
            temp[i][j] -= 1;
          }
        }
      }
      temp[selected][index] = false;
      setImagesLeft(imagesLeft + 1);
    } else {
      //Add to selected
      //increase the selected number counter
      temp[selected][index] = currentSelectedNumber;
      setCurrentSelectedNumber(currentSelectedNumber + 1);
      setImagesLeft(imagesLeft - 1);
    }
    // temp[selected][index] = !temp[selected][index];
    console.log(temp);
    setSelectedImageIndex(temp);
  };
  return (
    <>
      <div className={styles.main_div}>
        <div className={styles.top_header}>
          <div className={styles.gallery_header}>
            <img
              className={styles.upload_image_gallery_icon}
              src={gallery_icon}
              alt="top_gallery"
            />
            <div className={styles.gallery_header_text}>Gallery</div>
          </div>
          <div className={styles.gallery_selection_count_main}>
            写真を {imagesLeft} 枚選択し、完了ボタンを押して下さい
          </div>
          <div onClick={selectionDone} className={styles.image_selection_done}>
            選択完了
          </div>
        </div>

        <div className={styles.tab_section}>
          {/* <div className={styles.single_tab_row}></div> */}
          {Array.isArray(gallery) &&
            gallery.length > 0 &&
            gallery.map((item, index) => {
              console.log(item.title);
              if (item === 0) {
                return (
                  <div key={index} className={styles.tab_bottom_border}></div>
                );
              } else
                return (
                  <div
                    key={index}
                    onClick={() => {
                      setSelected(index);
                    }}
                    className={styles.single_tab}
                    style={{
                      height: selected === index ? "99px" : "60px",
                      transition: "height 0.3s ease-out",
                      backgroundColor:
                        index === gallery.length - 2 ? "white" : " #efeee5",
                      border:
                        index === gallery.length - 2
                          ? "1px solid #707070"
                          : "none",
                      borderBottom: "none",
                    }}
                  >
                    {index === gallery.length - 2 && (
                      <div className={styles.single_tab_fav_row}>
                        <i class="fa fa-bookmark" aria-hidden="true"></i>
                        <div className={styles.fav_spacing}></div>
                        {item.title}
                      </div>
                    )}
                    {index !== gallery.length - 2 && (
                      <div className={styles.single_tab_item_title}>
                        {item.title}
                      </div>
                    )}
                    {selected === index && index !== gallery.length - 2 && (
                      <div className={styles.single_tab_item_subtitle}>
                        {item.subtitle}
                      </div>
                    )}
                  </div>
                );
            })}
        </div>
        {galleryType[selected] === "UPLOAD" && (
          <div className={styles.free_gallery_not_uploaded_main}>
            <div className={styles.free_gallery_not_uploaded_header}>
              無料のギャラリーをアップロードしてください
            </div>
            <div
              onClick={() => {
                navigate("/album/create");
              }}
              className={styles.free_gallery_not_uploaded_button}
            >
              無料ギャラリーを作成
            </div>
          </div>
        )}
        {gallery.length > 1 && (
          <div className={styles.images_section}>
            {selected < gallery.length &&
              gallery[selected].images.map((item, index) => {
                return (
                  <div
                    className={styles.image_section_single_image_main}
                    key={index}
                    style={{
                      cursor: "pointer",
                    }}
                    onClick={() => {
                      // if (galleryType[selected] === "FREE") {
                      //   setPopUpIMGIndex(index);
                      //   setPopUpIMGArray(gallery[selected].images);
                      // }
                      alterSelection(index);
                    }}
                  >
                    <img
                      className={styles.image_section_single_image}
                      src={image_base_url + item.location}
                      alt="album_image"
                    />
                    {!selectedImageIndex[selected][index] && (
                      <div className={styles.imageUnselected_icon}></div>
                    )}
                    {selectedImageIndex[selected][index] && (
                      <div className={styles.imageSelected_icon}>
                        {selectedImageIndex[selected][index]}
                      </div>
                    )}
                  </div>
                );
              })}
          </div>
        )}
      </div>
    </>
  );
};
export default PhotoSelection;
